import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
	visitId: null,
	traffic_source_id: null,
	siteId: 424,
	user_ip: null,
	// Austin, TX fallback when Cloudflare geo headers are missing or non-US.
	// Mirrors FALLBACK_LOCATION in server/lib/middleware/geolocation.js exactly
	// (full region name, string lat/long) so the client-only initial state can't
	// diverge from what the server middleware sends.
	geolocation: {
		city: "Austin",
		region: "Texas",
		country: "US",
		latitude: "30.2672",
		longitude: "-97.7431"
	},
	// "fallback" = cloudflare couldn't resolve, using Austin TX default
	// "ip" = derived from Cloudflare headers (city-level precision)
	// "browser" = user granted navigator.geolocation (GPS precision)
	geolocationSource: "fallback"
};

export const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		setGeolocation: (state, action) => {
			state.geolocation = action.payload.geolocation;
			state.geolocationSource = action.payload.source;
		}
	}
});

export const { setGeolocation } = userSlice.actions;

export default userSlice.reducer;
